import { render, staticRenderFns } from "./paper-note-read-view.html?vue&type=template&id=732fefa6&scoped=true&external"
import script from "./paper-note-read-view.js?vue&type=script&lang=js&external"
export * from "./paper-note-read-view.js?vue&type=script&lang=js&external"
import style0 from "./paper-note-read-view.scss?vue&type=style&index=0&id=732fefa6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732fefa6",
  null
  
)

export default component.exports